import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Paper, InputBase } from '@material-ui/core';
import Icon from '../Icon/Icon';
import styles from './Searchbar.scss';

const Searchbar = ({ placeholder, onInputChange, className }) => {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event) => {
        const { target: { value } } = event;
        setInputValue(value);
        onInputChange(value);
    };

    return (
        <Paper className={classnames(styles.searchbar, className)}>
            <InputBase
                value={inputValue}
                placeholder={placeholder}
                onChange={handleInputChange}
            />
            <Icon name='ion-md-search' />
        </Paper>
    );
};

Searchbar.propTypes = {
    placeholder: PropTypes.string,
    onInputChange: PropTypes.func,
    className: PropTypes.string
};

export default Searchbar;

